import * as React from 'react'
import { includes } from 'lodash'

import Meta from '~/components/meta'
import EmbededPdfScreen from '~/screens/embeded-pdf'
import { getMetaInfo, redirectTo } from '~/utils'
import type { GetMetaInfoResult } from '~/utils/get-meta-info'

interface PrivacyPolicyPageProps {
  metaInfo: GetMetaInfoResult
  url: string
}

function PrivacyPolicyPage(props: PrivacyPolicyPageProps) {
  const { metaInfo, url } = props

  return (
    <>
      <Meta {...metaInfo} title="Política de Privacidad" noRobots />
      <EmbededPdfScreen url={url} />
    </>
  )
}

PrivacyPolicyPage.getInitialProps = (context: PageContext): PrivacyPolicyPageProps | void => {
  const { res } = context

  const { privacyPolicyUrl } = context.vendor

  if (!privacyPolicyUrl) {
    redirectTo('/', context)

    return
  }

  if (includes(privacyPolicyUrl, 'cloudinary')) {
    return {
      url: privacyPolicyUrl,
      metaInfo: getMetaInfo(context),
    }
  }

  if (res) {
    res.redirect(privacyPolicyUrl)
  } else if (typeof window !== 'undefined') {
    window.location.href = privacyPolicyUrl
  }
}

export default PrivacyPolicyPage
